import React, { useEffect, useReducer, useState } from 'react';
import {
  SimulatorContainer,
  SimulatorWrapper,
  SimulatorContent,
  SimulatorHeader,
  SimulatorHaderTitle,
  SimulatorHaderGrid,
  SimulatorSelectContainer,
  SimulatorSelectShowOptionSelect,
  SimulatorSelectShowOptionSelected,
  SimulatorSelectShowOptionContent,
  SimulatorSelectShowOptionSelectOption,
  SimulatorSelectShowOptionSelectedMessageError,
  SimulatorSelectLabel,
  SimulatorSelectActiveOption,
  SimulatorSelectOficeLabel, Container, SimulatorSelectOficeLabelBlack, SimulatorSelectOfficeImg, SimulatorSubSelectOficeLabelBlack
} from './styles';
import { H4 } from '../../components/Typography/styles';
import { BsCheck, BsChevronDown, BsExclamation } from 'react-icons/bs';
import { getDesks, getPiloto } from '../../services/desk';
import { SimulatorContext } from '../../store/';
import { BsInfo } from 'react-icons/bs';
import ModalAction from '../../components/ModalAction';
import simulatorReducer from '../../store/Simulator';
import ClientData from './ClientData';
import PriceValueToSolicitate from './PriceValueToSolicitate';
import FinancesData from './FinancesData';
import Result from './Result';
import INITIAL_STATE_SIMULATOR from '../../store/Simulator/state';
import Copyright from '../../components/Copyright';
import { simulatorSteps, credits, contactMeans } from '../../helpers/enum';
import colors from '../../assets/styles/colors';
import FormSteps from '../../components/FormSteps';
import NewFormSteps from '../../components/FormStepsSimulator';
import Loader from '../../components/Loader';
import { useLocation } from 'react-router-dom';
import { getSimulacionById } from '../../services/simulation';
import { default as SimulatorTypes } from '../../store/Simulator/types';
import { formatPhone } from '../../helpers/string';
import { handleChangeIdentification } from '../../helpers/price';
import SelectOffice from '../../components/SelectOffice';
import SelectOfficeImg from '../../assets/images/SelectOfficeImg.svg'
import SearchField from '../../components/SearchField';
import SearchFieldOffice from '../../components/SearchFieldOffice';
import { isPricing } from '../../services/tasas';
import OldClientDataPage from './OldClientData';
import OldPriceValueToSolicitatePage from './OldPriceValueToSolicitate';
import OldResultPage from './OldResult';
import InputDefault from '../../components/InputDefault';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { FormRow } from '../../components/FormTemplate/styles';
import Select from '../../components/Select';
import { getDominioCorreo, getDominioCorreoConfirmados } from '../../services/dominioCorreo';
import { ClientDataButtoCalculate, ClientDataButtoCalculateButton, SimulatorConteinerButton } from './PriceValueToSolicitate/styles';
import InputPhone from '../../components/InputPhone';
import { enviarNotificacionHabeasData } from '../../services/habeasData';
import ModalActionSendIdValidation from '../../components/ModalActionSendIdValidation';
import SearchFieldCategories from '../../components/SearchFieldCategories';
import { identificationType } from '../../helpers/enum';
import InputFileBackGroundImage from '../../components/InputFileBackGroundImage';
import { useDropzone } from "react-dropzone";

const SimulatorPage = () => {
  const location = useLocation();
  const [simulator, setSimulator] = useReducer(simulatorReducer, INITIAL_STATE_SIMULATOR);
  const { register, handleSubmit, watch, setValue, control, clearErrors, errors } = useForm({});
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const [showDesk, setShowDesk] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [desks, setDesks] = useState([]);
  const [deskError, setDeskError] = useState({});
  const [activeStep, setActiveStep] = useState(simulatorSteps.PRICE_VALUE_TO_SOLICITATE);
  const [lastStep, setLastStep] = useState(simulatorSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);
  const [simulatorDesks, setSimulatorDesks] = useState([]);
  const [showSimulatorDesks, setShowSimulatorDesks] = useState(false);
  const [filteredSimulatorDesks, setFilteredSimulatorDesks] = useState([]);
  const [newPricing, setNewPricing] = useState(false);
  const [showDominioCorreo, setShowDominioCorreo] = useState(false);
  const [anotherDominioCorreo, setAnotherDominioCorreo] = useState(false);
  const [dominiosCorreo, setDominiosCorreo] = useState([]);
  const [showDominioCorreo2, setShowDominioCorreo2] = useState(false);
  const fields = watch();
  const [showModalInfoCorreo, setShowModalInfoCorreo] = useState(false);
  const [showModalNotificacion, setShowModalNotificacion] = useState(false);
  const [messageModalNotificacion, setMessageModalNotificacion] = useState('');
  const [showModalNotificacionError, setShowModalNotificacionError] = useState(false);
  const [validFormulario, setValidFormulario] = useState(false);
  const emailValue = useWatch({ control, name: 'email' });
  const dominioValue = useWatch({ control, name: 'dominioCorreoNuevo' });
  const dominioValue2 = useWatch({ control, name: 'dominioCorreoNuevo2' });
  const emailValue2 = useWatch({ control, name: 'email2' });
  const [dominiosCorreoConfirmados, setDominiosCorreoConfirmados] = useState([]);
  const [filteredDominiosCorreoConfirmados, setFilteredDominiosCorreoConfirmados] = useState([]);
  const [filteredDominiosCorreo, setFilteredDominiosCorreo] = useState([]);
  const [dominioCorreo, setDominioCorreo] = useState('');
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  async function initializedStateComponent() {
    try {
      setIsLoading(true);
      const { data } = await getDesks(session.idAsesor);
      setSimulatorDesks(data);
      const dominiosCorreo = await getDominioCorreo();
      const dominiosCorreoConfirmados = await getDominioCorreoConfirmados();
      setDominiosCorreoConfirmados(dominiosCorreoConfirmados.data);
      setDominiosCorreo(dominiosCorreo.data);
      if (location.idSimulation) {
        const simulationResponse = await getSimulacionById(location.idSimulation);
        const desk = data.find(item => item.id === simulationResponse.data.idOficina);
        const creditLine = credits.find(item => item.idBackend === simulationResponse.data.idLineaCredito);
        const contactMean = simulationResponse.data.medioContacto ? contactMeans.find(item => item.id === simulationResponse.data.medioContacto) : null;

        await setSimulator({
          type: SimulatorTypes.SET_SAVED_SIMULATION,
          clientData: {
            nombres: simulationResponse.data.cliente.nombres,
            primerNombre: simulationResponse.data.cliente.primerNombre || nombresPart(simulationResponse.data.cliente.nombres, 0),
            segundoNombre: simulationResponse.data.cliente.segundoNombre || nombresPart(simulationResponse.data.cliente.nombres, 1),
            primerApellido: simulationResponse.data.cliente.primerApellido || nombresPart(simulationResponse.data.cliente.nombres, 2),
            segundoApellido: simulationResponse.data.cliente.segundoApellido || nombresPart(simulationResponse.data.cliente.nombres, 3),
            identificacion: handleChangeIdentification(simulationResponse.data.cliente.identificacion),
            tipoIdentificacion: simulationResponse.data.cliente.tipoIdentificacion,
            fechaNacimiento: simulationResponse.data.cliente.fechaNacimiento,
            edad: simulationResponse.data.cliente.edad,
            celular: formatPhone(simulationResponse.data.cliente.celular),
            email: simulationResponse.data.cliente.email,
            actividadCliente: simulationResponse.data.actividadCliente,
            pagaduria: simulationResponse.data.pagaduria,
            medioContacto: contactMean,
            genero: simulationResponse.data.genero,
            departamento: simulationResponse.data.departamento,
            ciudad: simulationResponse.data.ciudad,
            estrato: simulationResponse.data.estrato,
          },
          priceValueToSolicitate: {
            monto: simulationResponse.data.monto,
            tasa: simulationResponse.data.tasa,
            plazo: simulationResponse.data.plazo,
            diasInteresesIniciales: simulationResponse.data.diasInteresesIniciales,
            totalActivos: simulationResponse.data.totalActivos,
            tipoContrato: simulationResponse.data.tipoContrato,
            nivelEscolaridad: simulationResponse.data.nivelEducativo,
          },
          financesData: {
            ingresos: simulationResponse.data.ingresos,
            descuentosLey: simulationResponse.data.descuentosLey,
            descuentosNomina: simulationResponse.data.descuentosNomina,
            lineaCredito: creditLine,
            credits: [],
            fields: [{ id: 0, value: '' }]
          },
        });

        setDeskSelected(desk);
      }

      setDesks(data.sort((x, y) => x.nombre.localeCompare(y.nombre)));
      setIsLoading(false);
    } catch (error) {
      console.log(error.response)
    }
  }

  function setDeskSelected(desk) {
    setSimulator({
      type: "SET_DESK",
      desk: desk
    })
  }

  const onChangeEmail = (e) => {
    const lowercaseEmail = e.target.value.toLowerCase();
    setValue('email', lowercaseEmail);
  };

  useEffect(() => {
    const lowercaseEmail = emailValue?.toLowerCase();
    setValue('email', lowercaseEmail);
  }, [emailValue, setValue]);

  useEffect(() => {
    const lowercaseEmail = emailValue2?.toLowerCase();
    setValue('email2', lowercaseEmail);
  }, [emailValue2, setValue]);

  useEffect(() => {
    const lowercaseEmail = dominioValue?.toLowerCase();
    setValue('dominioCorreoNuevo', lowercaseEmail);
  }, [dominioValue, setValue]);

  useEffect(() => {
    const lowercaseEmail = dominioValue2?.toLowerCase();
    setValue('dominioCorreoNuevo2', lowercaseEmail);
  }, [dominioValue2, setValue]);

  const handleCopy = (event) => {
    event.preventDefault();
  };

  const handlePaste = (event) => {
    event.preventDefault();
  };

  function setSelectedDominioCorreo(dominioCorreo,name) {
    console.log(dominioCorreo)
    setValue("dominioCorreo", dominioCorreo?.nombre);
    setValue("dominioCorreo2", dominioCorreo?.nombre);
    setDominioCorreo(dominioCorreo)
    clearErrors("dominioCorreo", {});
    clearErrors("dominioCorreo2", {});
    dominioCorreo?.nombre == 'Agregar otro dominio' ? setAnotherDominioCorreo(true) : setAnotherDominioCorreo(false);
    setSimulator({
      type: SimulatorTypes.SET_DOMINIO_CORREO,
      dominioCorreo: dominioCorreo
    })
    setShowDominioCorreo(false);
    setShowDominioCorreo2(false);
  }

  function onBlurEmail2() {
    if (fields.email !== fields.email2) {
      setShowModalInfoCorreo(true)
    }
  }

  function giveUpSimulation() {
    setShowModal(false);
    window.location.reload();
  }

  function searchInSimulatorDesks(e) {
    setShowSimulatorDesks(true);
    let filtered = desks.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredSimulatorDesks(filtered);
  }

  function searchInDominios(e) {
    setShowDominioCorreo(true);
    let filtered = dominiosCorreo.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    let filtered2 = dominiosCorreoConfirmados.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredDominiosCorreo(filtered);
    setFilteredDominiosCorreoConfirmados(filtered2);
  }

  function searchInDominios2(e) {
    setShowDominioCorreo2(true);
    let filtered = dominiosCorreo.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    let filtered2 = dominiosCorreoConfirmados.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredDominiosCorreo(filtered);
    setFilteredDominiosCorreoConfirmados(filtered2);
  }

  function nombresPart(nombres, part) {
    var parts = nombres.split(' ', 4);
    return parts.length < part ? '' :
      // Caso Nombre y Apellido
      parts.length == 2 ? [parts[0], '', parts[1], ''][part] :
        // Cualquier otro caso
        parts[part];
  }

  useEffect(() => {
    initializedStateComponent();
    return () => setDesks([]);
  }, [])

  useEffect(() => {
    if (simulator.desk.id) {
      ispricing();
    }
  }, [simulator.desk.id]);

  async function ispricing() {
    setIsLoading(true)
    const isPiloto = await getPiloto(simulator.desk.id);
    if (isPiloto.data.isNuevoSimulador) {
      setNewPricing(true);
    } else {
      setNewPricing(false);
    }
    const isPricingResponse = await isPricing(simulator.desk.id);
    await setSimulator({
      type: SimulatorTypes.SET_PRICING,
      pricing: isPricingResponse.data
    })
    setIsLoading(false)
  }

  async function enviarNotificacion() {
    try {
      const validarDominio = anotherDominioCorreo ? (fields.dominioCorreoNuevo === fields.dominioCorreoNuevo2) : true;
      console.log(fields.email === fields.email2)
      if ((fields.email === fields.email2) && validarDominio) {
        setIsLoading(true);
        const data = {
          email: anotherDominioCorreo ? fields.email + fields.dominioCorreoNuevo : fields.email + simulator.clientData.dominioCorreo.nombre,
          celular: fields.celular.replace(/\s+/g, ''),
          idAsesor: session.idAsesor,
          identificacion: fields.identificacion.replaceAll('.', '')
        };

        const envioHabeasData = await enviarNotificacionHabeasData(data);

        const statusCode = Number(envioHabeasData.data.statusCode);
        console.log(statusCode)
        setMessageModalNotificacion(envioHabeasData.data.message);
        if (statusCode === 200) {
          setShowModalNotificacion(true);
        } else if (statusCode === 400) {
          setShowModalNotificacionError(true);
        } else if (statusCode === 201) {
          setShowModalNotificacion(true);
        } else if (statusCode === 202) {
          setShowModalNotificacion(true);
        }
        setIsLoading(false);
      } else {
        setMessageModalNotificacion('El correo electrónico no coincide')
        setShowModalNotificacionError(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const validarDominio = anotherDominioCorreo ? (fields.dominioCorreoNuevo && fields.dominioCorreoNuevo2) : true;
    /*let data = {
      validarDominio: validarDominio,
      celular: fields.celular,
      email: fields.email,
      email2: fields.email2,
      dominioCorreo: simulator.clientData.dominioCorreo?.nombre
    }
    console.log(data)*/

    if(fields.celular && fields.email && fields.email2 && validarDominio && simulator.clientData.dominioCorreo?.nombre && fields.identificacion){
      setValidFormulario(true);
    } else {
      setValidFormulario(false);

    } 
  }, [fields.celular,fields.email, simulator.clientData.dominioCorreo?.nombre,fields.dominioCorreoNuevo,fields.dominioCorreoNuevo2,fields.email2, fields.identificacion])
  
  

  function onChangeIdentification(e) {
    var identificacion = undefined;
    if (simulator.clientData.tipoIdentificacion.value === 'CE') {
      identificacion = e.target.value;
    } else {
      identificacion = handleChangeIdentification(e.target.value);
    }
    setValue('identificacion', identificacion);
  }
  function removeFile(key) {
    const file = simulator.clientData.identityPhoto.filter(
      (value, index) => index !== key
    );

    /*setClientRegistration({
      type: ClientRegistrationTypes.REMOVE_IDENTITY_PHOTO_FILE,
      file,
    });*/
  }

  function onDrop(file) {
    if (file[0].size / Math.pow(1024, 2) > 10) {
      //setShowModalInfo(true);
    } else {
      if (simulator.clientData.identityPhoto.length <= 1) {
        //setCanAddFile(false);
        setSimulator({
          type: SimulatorTypes.ADD_IDENTITY_PHOTO_FILE,
          file,
        });
      }
    }
  }

  return (
    <SimulatorContainer id="simulator-page">
      <SimulatorWrapper>
        <SimulatorHeader>
          <SimulatorHaderTitle>Simulación</SimulatorHaderTitle>
          <SimulatorHaderGrid>
            <H4 color="#2A2C31">Simulador</H4>
            <SimulatorSelectContainer id="select-office">
              {activeStep > simulatorSteps.CLIENT_DATA && <SimulatorSelectActiveOption>{simulator.desk.nombre}</SimulatorSelectActiveOption>}
              {activeStep === simulatorSteps.PRICE_VALUE_TO_SOLICITATE && <></>}
              {activeStep === simulatorSteps.PRICE_VALUE_TO_SOLICITATE && (
                <>
                  {simulator.desk && <>
                    <SimulatorSelectLabel>Oficina Asesor</SimulatorSelectLabel>
                    <SimulatorSelectShowOptionSelect open={showDesk} className={deskError && 'error'} onClick={() => activeStep === simulatorSteps.PRICE_VALUE_TO_SOLICITATE && setShowDesk(!showDesk)}>
                      <SimulatorSelectShowOptionSelected className={!simulator.desk ? 'default' : ''}>{!simulator.desk ? 'Seleccionar...' : simulator.desk.nombre}</SimulatorSelectShowOptionSelected>
                      {activeStep === simulatorSteps.PRICE_VALUE_TO_SOLICITATE && <BsChevronDown size={10} />}
                      <SimulatorSelectShowOptionContent open={showDesk}>
                        {desks.map((item, key) => (
                          <SimulatorSelectShowOptionSelectOption onClick={() => setDeskSelected(item)} key={key}>{item.nombre}</SimulatorSelectShowOptionSelectOption>
                        ))}
                      </SimulatorSelectShowOptionContent>
                    </SimulatorSelectShowOptionSelect>
                    {deskError && <SimulatorSelectShowOptionSelectedMessageError error={deskError}>{deskError.message}</SimulatorSelectShowOptionSelectedMessageError>}
                  </>}
                </>
              )}
            </SimulatorSelectContainer>
          </SimulatorHaderGrid>
        </SimulatorHeader>

        {isLoading ? <Loader /> : (
          <>
            {activeStep === simulatorSteps.PRICE_VALUE_TO_SOLICITATE && !simulator.desk &&
              <div style={{ width: 'auto', display: 'flex', flexDirection: 'column', marginLeft: '10%',marginTop:'10%' }}>
                {/*
                <Container style={{width:'100%', display:'flex', flexDirection:'column',marginLeft:'15%'}}>
                  <SimulatorSelectOfficeImg src={SelectOfficeImg}></SimulatorSelectOfficeImg>
                  <SimulatorSelectOficeLabel>Autorización de tratamiento de datos personales</SimulatorSelectOficeLabel>
                  <SimulatorSelectOficeLabelBlack>Para iniciar el proceso de autorización, por favor envíe notificación</SimulatorSelectOficeLabelBlack>
                  <div>
                    <FormRow col="3">
                    <Controller
              name="identificacion"
              control={control}
              value={simulator.clientData.identificacion}
              render={() => (
                <InputDefault
                  name="identificacion"
                  label="Número de documento de identidad"
                  register={register({
                    required: "Este dato es obligatorio",
                    pattern: {
                      value: /^\d+(\.\d+)*$/,
                      message: "Error en el número, ingresa uno válido",
                    }
                  })}
                  id="identificacion"
                  error={errors.identificacion}
                  maxLength={simulator.clientData.tipoIdentificacion.value === 'CE' ? identificationType.ce.max : identificationType.cc.max}
                  minLength={simulator.clientData.tipoIdentificacion.value === 'CE' ? identificationType.ce.min : identificationType.ce.min}
                  onChange={onChangeIdentification}
                />
              )}
            />
                      <Controller
                        as={InputPhone}
                        control={control}
                        label="Celular"
                        name="celular"
                        register={register({
                          required: "Este dato es obligatorio",
                          pattern: {
                            value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                            message: "Error en el número, ingresa uno válido",
                          },
                        })}
                        id="celular"
                        error={errors.celular}
                        mask="999 999 99 99"
                        value={simulator.clientData.celular} />
                    </FormRow>
                    <FormRow col="3">
                      <Controller
                        as={InputDefault}
                        control={control}
                        label="Correo Electrónico"
                        name="email"
                        onChange={onChangeEmail}
                        onCopy={handleCopy}
                        onPaste={handlePaste}
                        register={register({
                          required: "Este dato es obligatorio",
                        })}
                        id="email"
                        error={errors.email}
                        value={simulator.clientData.email}
                      />
                      <SearchFieldCategories
                        label="Dominio Correo Electrónico"
                        name="dominioCorreo"
                        id="dominioCorreo"
                        show={showDominioCorreo}
                        subcategory1={'Dominios sugeridos'}
                        list={filteredDominiosCorreoConfirmados}
                        subcategory2={'Otros dominios'}
                        list2={filteredDominiosCorreo}
                        defaultValue={dominioCorreo?.nombre}
                        selectField={setSelectedDominioCorreo}
                        searchInList={searchInDominios}
                        register={register}
                        placeholder="Buscar..."
                        error={errors.dominioCorreo}
                      />
                      {anotherDominioCorreo &&
                        <Controller
                          as={InputDefault}
                          control={control}
                          label="Dominio Correo Electrónico"
                          name="dominioCorreoNuevo"
                          onChange={onChangeEmail}
                          onCopy={handleCopy}
                          onPaste={handlePaste}
                          register={register({
                            required: "Este dato es obligatorio",
                            pattern: {
                              value: /@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
                              message: "El dominio del correo electrónico tiene un formato inválido"
                            }
                          })}
                          id="dominioCorreoNuevo"
                          error={errors.dominioCorreoNuevo}
                          value={simulator.clientData.dominioCorreoNuevo}
                        />}
                    </FormRow>
                    <FormRow col="3">
                      <Controller
                        as={InputDefault}
                        control={control}
                        onCopy={handleCopy}
                        onPaste={handlePaste}
                        label="Confirmar Correo Electrónico"
                        name="email2"
                        //onChange={onChangeEmail}
                        register={register({
                          required: "Este dato es obligatorio",
                        })}
                        id="email2"
                        error={errors.email}
                        value={simulator.clientData.email}
                        onBlur={onBlurEmail2}
                      />
                     <SearchFieldCategories
                        label="Confirmar Dominio Correo Electrónico"
                        name="dominioCorreo2"
                        id="dominioCorreo2"
                        show={showDominioCorreo2}
                        subcategory1={'Dominios sugeridos'}
                        list={filteredDominiosCorreoConfirmados}
                        subcategory2={'Otros dominios'}
                        list2={filteredDominiosCorreo}
                        defaultValue={dominioCorreo?.nombre}
                        selectField={setSelectedDominioCorreo}
                        searchInList={searchInDominios2}
                        register={register}
                        placeholder="Buscar..."
                        error={errors.dominioCorreo}
                      />
                      {anotherDominioCorreo &&
                        <Controller
                          as={InputDefault}
                          control={control}
                          onCopy={handleCopy}
                          onPaste={handlePaste}
                          label="Confirmar Dominio Correo Electrónico"
                          name="dominioCorreoNuevo2"
                          onChange={onChangeEmail}
                          register={register({
                            required: "Este dato es obligatorio",
                            pattern: {
                              value: /@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
                              message: "El dominio del correo electrónico tiene un formato inválido"
                            }
                          })}
                          id="dominioCorreoNuevo2"
                          error={errors.dominioCorreoNuevo}
                          value={simulator.clientData.dominioCorreoNuevo}
                        />}
                    </FormRow>
                    <FormRow>
                    </FormRow>
                    <br></br>
                    <SimulatorSubSelectOficeLabelBlack>Estimado cliente, para dar continuidad a su solicitud es necesario que nos autorice el tratamiento de datos personales. Por tal razón, en este momento ExcelCredit le enviará a su WhatsApp y correo electrónico un link para acceder al formato y una vez haga lectura y esté de acuerdo, proceda con la autorización ingresando el código temporal OTP que le llegará en el mismo mensaje.</SimulatorSubSelectOficeLabelBlack>
                    <SimulatorConteinerButton>
                      <ClientDataButtoCalculateButton style={{ marginTop: '10px' }} type="button" disabled={!validFormulario} onClick={() => enviarNotificacion()} id="calculate">Enviar notificación</ClientDataButtoCalculateButton>
                    </SimulatorConteinerButton>
                  </div>
                </Container>*/}
                <Container>
                  <SimulatorSelectOfficeImg src={SelectOfficeImg}></SimulatorSelectOfficeImg>
                  <SimulatorSelectOficeLabel>Seleccione una oficina</SimulatorSelectOficeLabel>
                  <SimulatorSelectOficeLabelBlack>Para iniciar el proceso de simulación, por favor seleccione una oficina</SimulatorSelectOficeLabelBlack>
                  <SearchFieldOffice
                    label=""
                    name="Oficina"
                    id="Oficina"
                    show={showSimulatorDesks}
                    list={filteredSimulatorDesks}
                    selectField={setDeskSelected}
                    searchInList={searchInSimulatorDesks}
                    placeholder="Buscar..."
                  />
                </Container>
              </div>
            }

            <SimulatorContent style={newPricing ? { display: 'grid', marginTop: '40px' } : { display: 'grid', gridTemplateColumns: '260px 1fr', marginTop: '40px' }}>
              {simulator.desk && newPricing &&
                <NewFormSteps lastStep={lastStep} steps={[
                  { number: simulatorSteps.PRICE_VALUE_TO_SOLICITATE, label: 'Valores crédito a solicitar' },
                  //{ number: simulatorSteps.RESULT, label: 'Resultado' },
                  { number: simulatorSteps.CLIENT_DATA, label: 'Datos cliente' }
                ]} />
              }
              {simulator.desk && !newPricing &&
                <FormSteps lastStep={lastStep} steps={[
                  { number: simulatorSteps.PRICE_VALUE_TO_SOLICITATE, label: 'Valores crédito a solicitar' },
                  { number: simulatorSteps.CLIENT_DATA, label: 'Datos cliente' },
                  { number: simulatorSteps.RESULT, label: 'Resultado' },

                ]} />
              }
              <SimulatorContext.Provider value={{ simulator, setSimulator }}>

                {activeStep === simulatorSteps.CLIENT_DATA && newPricing && (
                  <ClientData
                    setActiveStep={setActiveStep}
                    setLastStep={setLastStep}
                    setDeskError={setDeskError}
                    setShowModal={setShowModal} />
                )}




                {activeStep === simulatorSteps.PRICE_VALUE_TO_SOLICITATE && simulator.desk && newPricing && (
                  <PriceValueToSolicitate
                    setActiveStep={setActiveStep}
                    setLastStep={setLastStep}
                    setShowModal={setShowModal} />
                )}



                {activeStep === simulatorSteps.RESULT && newPricing && (
                  <Result
                    setActiveStep={setActiveStep}
                    setLastStep={setLastStep}
                    setShowModal={setShowModal} />
                )}

                {activeStep === simulatorSteps.CLIENT_DATA && !newPricing && (
                  <OldClientDataPage
                    setActiveStep={setActiveStep}
                    setLastStep={setLastStep}
                    setDeskError={setDeskError}
                    setShowModal={setShowModal} />
                )}




                {activeStep === simulatorSteps.PRICE_VALUE_TO_SOLICITATE && simulator.desk && !newPricing && (
                  <OldPriceValueToSolicitatePage
                    setActiveStep={setActiveStep}
                    setLastStep={setLastStep}
                    setShowModal={setShowModal} />
                )}


                {activeStep === simulatorSteps.RESULT && !newPricing && (
                  <OldResultPage
                    setActiveStep={setActiveStep}
                    setLastStep={setLastStep}
                    setShowModal={setShowModal} />
                )}

              </SimulatorContext.Provider>

              <ModalAction
                open={showModal}
                setShowModal={setShowModal}
                actionFunctionUpButton
                actionFunctionDownButton={giveUpSimulation}
                title="¿Deseas abandonar la simulación?"
                //actionLabelFunctionUpButton="Guardar simulación"
                actionLabelFunctionDownButton="Abandonar"
                backgroundIcon={colors.grayLight}
                bodyIcon={<BsInfo size={32} color={colors.bgPrimary} id="info-icon" />} />
              <ModalActionSendIdValidation
                open={showModalNotificacion}
                actionFunctionDownButton={() => setShowModalNotificacion(false)}
                actionLabelFunctionDownButton="Continuar"
                description={messageModalNotificacion}
                bodyIcon={<BsCheck id="message" size={32} color={colors.white} />}
                backgroundIcon={colors.textHyperlink} />
              <ModalActionSendIdValidation
                open={showModalNotificacionError}
                actionFunctionDownButton={() => setShowModalNotificacionError(false)}
                actionLabelFunctionDownButton="Continuar"
                description={messageModalNotificacion}
                bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
                backgroundIcon={colors.bgDanger} />
            </SimulatorContent>
          </>
        )}
      </SimulatorWrapper>
      <Copyright />
    </SimulatorContainer>

  )
}

export default SimulatorPage;
